import React from 'react'

import i18n from 'translations'

export const FormationRules = [
  {
    name: i18n.t('functional-areas:formationRules'),
    component: React.lazy(() => import('../../modules/ecommerceStudent/ComplementaryFormation')),
    path: '/ecommerce-student/complementary-formation',
    guards: ['allowOnlyEcommerceStudent', 'allowOnlyLogged'],
  },
  {
    name: i18n.t('functional-areas:formationRules'),
    component: React.lazy(() => import('../../modules/ecommerceStudent/ComplementaryFormationDetail')),
    path: '/ecommerce-student/complementary-formation/:curriculumId',
    guards: ['allowOnlyEcommerceStudent', 'allowOnlyLogged'],
  },
]
